import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  TableChart as CsvIcon,
  GridOn as ExcelIcon,
  PictureAsPdf as PdfIcon,
} from '@mui/icons-material';
import { Vocabulary } from '../../Utils/Vocabulary';

export type ExportFormat = 'csv' | 'excel' | 'pdf';

interface ExportFormatSelectorProps {
  value: ExportFormat;
  onChange: (format: ExportFormat) => void;
  disabled?: boolean;
}

const ExportFormatSelector: React.FC<ExportFormatSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (event: SelectChangeEvent<ExportFormat>) => {
    onChange(event.target.value as ExportFormat);
  };

  const formats = [
    { value: 'csv' as ExportFormat, label: Vocabulary.csv, icon: <CsvIcon /> },
    { value: 'excel' as ExportFormat, label: Vocabulary.excel, icon: <ExcelIcon /> },
    { value: 'pdf' as ExportFormat, label: Vocabulary.pdf, icon: <PdfIcon /> },
  ];

  return (
    <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }} disabled={disabled}>
      <InputLabel id="export-format-label">{Vocabulary.exportFormat}</InputLabel>
      <Select
        labelId="export-format-label"
        id="export-format-select"
        value={value}
        onChange={handleChange}
        label={Vocabulary.exportFormat}
      >
        {formats.map((format) => (
          <MenuItem key={format.value} value={format.value}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              {format.icon}
            </ListItemIcon>
            <ListItemText>{format.label}</ListItemText>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ExportFormatSelector;
